import { render, staticRenderFns } from "./CCLabel.vue?vue&type=template&id=32c690d8&scoped=true"
import script from "./CCLabel.vue?vue&type=script&lang=js"
export * from "./CCLabel.vue?vue&type=script&lang=js"
import style0 from "./CCLabel.vue?vue&type=style&index=0&id=32c690d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c690d8",
  null
  
)

export default component.exports